export { Icon } from "./Components/Icon/Icon";
export { IconSize } from "./Components/Icon/Icon.Props";
